import { put, takeEvery } from "redux-saga/effects"
import { fetchGraphMethod } from "../../../services/httpService"
import messagePopup from "../../../utils/messagePopup"

// ========================================== Action Type =====================================================
export const actionType = {
    GRADE_LIST_START: 'GRADE_LIST_START',
    GRADE_LIST_SUCCESS: 'GRADE_LIST_SUCCESS',
    GRADE_LIST_FAILED: 'GRADE_LIST_FAILED'
}

// ============================================ Actions ========================================================
export const gradeListStart = (data) => ({
   type: actionType.GRADE_LIST_START,
   payload: data
})

export const  gradeListSuccess = (data) => ({
    type: actionType.GRADE_LIST_SUCCESS,
    payload: data
})

export const  gradeListFailed = (data) => ({
    type: actionType.GRADE_LIST_FAILED,
    payload: data
})

// =========================================== Reducer ===========================================================
const INIT_STATE = {
    loading: false,
    data: null,
    error: null
}

export default function  gradeListReducer(state = INIT_STATE,action){
  switch(action.type){
      case actionType.GRADE_LIST_START: 
        return {
            ...state,
            loading: true
        }
      case actionType.GRADE_LIST_SUCCESS:
        return {
            ...state,
            loading: false,
            data: action.payload,
            error: null
        }  
      case actionType.GRADE_LIST_FAILED:
        return {
            ...state,
            loading: false,
            data: null,
            error: action.payload
        }       
      default: return {...state}  
  }
} 

// ===================================================== side effect =============================================

export function* gradeListSaga(action){
   try {
    const response = yield fetchGraphMethod(action.payload.query,null,true);
    if(response && response.status === 200){
       const allGrades = response.data.data.allGrades.Grades ? response.data.data.allGrades.Grades : null
       yield put( gradeListSuccess(allGrades));
    } else {
      messagePopup('','GRADE List failed','error')   
      yield put( gradeListFailed('GRADE List failed')) 
    }
   } catch (error) {
     messagePopup('','GRADE List failed','error')   
     yield put( gradeListFailed('GRADE List failed')) 
   }
}

export function* watchGradeListSaga(){
    yield takeEvery(actionType.GRADE_LIST_START, gradeListSaga)
}